import { NotFoundError } from '@cian/peperrors/shared';

import { prepareRegions } from './mappers/prepareRegions';
import { IRegion } from './types';
import { ResponseError } from '../../errors/responseError';
import {
  fetchGetRegionsByPoint,
  IGetRegionsByPointRequest,
  TGetRegionsByPointResponse,
} from '../../repositories/geo/v1/get-regions-by-point';
import { IApplicationContext } from '../../types/applicationContext';
import { NonEmptyArray } from '../../types/nonEmptyArray';

export async function getRegionsByPoint(
  context: IApplicationContext,
  parameters: IGetRegionsByPointRequest,
): Promise<NonEmptyArray<IRegion>> {
  const { httpApi, logger } = context;

  try {
    const response: TGetRegionsByPointResponse = await fetchGetRegionsByPoint({
      httpApi,
      parameters,
    });

    if (response.statusCode !== 200) {
      throw new NotFoundError({
        domain: 'services.getRegionsByPoint',
        message: 'Не удалось получить список регионов по координатам',
      });
    }

    const regions = prepareRegions(response.response.regionLocations);
    if (!regions) {
      throw new ResponseError({
        domain: 'services.getRegionsByPoint',
        message: 'Полнота полученных данных в списке регионов не соответствует требованиям',
      });
    }

    return regions;
  } catch (ex) {
    logger.error(ex);

    throw ex;
  }
}
